import React, { Component, useState, useEffect } from "react";
import { Row, Col, Label, Button, Container } from "reactstrap";
import { inject, observer } from "mobx-react";
import Card from "../../../comum/components/Card";
import ImportacaoDetalhesStore from "../stores/ImportacaoDetalhesStore";
import {
    IconeNaoMsgLida,
    IconeSetaDescer,
    IconeSetaSubir,
    Monitor,
    StatusOk,
    StatusWarning,
    IconeCarregar, Baixar, IconeDelete
} from "../../../comum/components/Icones";
import Footer from "../../../comum/components/Footer";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import FormSelectSimples from "../../../comum/components/FormSelectSimples";
import { ImportacaoDocsImportar } from "./ImportacaoDocsImportar";
import ImportacaoService from "../../../../services/ImportacaoService";
import { ImportacaoNotasAdicionar } from "./ImportacaoNotasAdicionar";
import FormInputSimples from "../../../comum/components/FormInputSimples";
import ModalForm from "../../../comum/components/ModalForm";
import { situacaoFormatter } from "../../../../utils/formatar";
import ModalAviso from "../../../comum/components/ModalAviso";
import _ from "lodash";

@inject("store")
@observer
export class ImportacaoDetalhes extends Component {
    constructor(props) {
        super(props);

        this.service = new ImportacaoService();

        this.controllerImportacao = this.props.controller;
        this.controller = new ImportacaoDetalhesStore(this.service);
        this.validacaoStore = this.props.store.validacaoStore;
        this.addColDocs();
        this.addColNotas();
        this.mudarTipoDocValue = null;

        this.handleDesistencia = this.handleDesistencia.bind(this)
    };
    componentDidMount() {
        if(this.controllerImportacao.detalhes.Email != null && this.controllerImportacao.detalhes.Email.length > 0){
            this.controller.email = true;

            console.log("Retornando...", this.controllerImportacao.detalhes)
            
        }
        console.log("Passou no disMount")
    }
    addColDocs = () => {
        this.controller.colunasDocumentos.push({
            dataField: 'vis',
            isDummyField: true,
            text: 'Visualizar',
            align: (cell, row, rowIndex, colIndex) => 'center',
            formatter: (cell, row) => {
                return <div>
                    <Baixar className="" cor={`${row.DatInativo ? '#93A0AD' : '#001C43'}`} tamanho="2x" onClick={() => this.controller.visualizarDocumento(row)} />
                </div>
            }
        });
        this.controller.colunasDocumentos.push({
            dataField: 'exc',
            isDummyField: true,
            text: 'Inativar',
            align: (cell, row, rowIndex, colIndex) => 'center',
            formatter: (cell, row) => {
                return  <div>
                            {row.FlgInativar === "S" &&                           
                            <IconeDelete className="" tamanho="2x" onClick={() => this.controller.inativarDocumento(row.InfDocId, row.ProtocoloId, "DOC")} />}
                        </div>
            }
        });
    };

    addColNotas = () => {
        this.controller.colunasNotas.push({
            dataField: 'exc',
            isDummyField: true,
            text: 'Inativar',
            align: (cell, row, rowIndex, colIndex) => 'center',
            formatter: (cell, row) => {
                return <div> { this.controllerImportacao.detalhes.Situacao != 'OK' && 
                    <IconeDelete className="" tamanho="2x" onClick={() => this.controller.inativarDocumento(row.Id, row.ProtId, "NOTA")} />
                } </div>
            }
        });
    };

    handleFechar = () => {
        this.controllerImportacao.detalhesAtivo = false;
        window.scrollTo(10, 10); // Bug da barra de rolagem com o cabeçalho do grid
        this.props.mudaTitulo();
    };

    modalInativar = () => {
        if (this.controller.mostrarModalInativar)
            if (this.controller.mostrarModalInativar === "DOC") {
                return <ModalForm salvando={this.controller.salvando} className="area-form-modal"
                    onClickCancelar={() => this.controller.mostrarModalInativar = false}
                    labelConfirmar='SIM' labelCancelar="NÃO"
                    onClickSalvar={() => this.controller.confirmaInativar(() => this.controllerImportacao.atualizaDocumentos(this.controllerImportacao.linhaDetalhes.BlId, this.controllerImportacao.linhaDetalhes.NumeroBl, this.controllerImportacao.linhaDetalhes.ProtocoloId))} >
                    <h2>Confirma a inativação?</h2>
                    {this.controller.deuErrado && <Label className="label-danger">{this.controller.deuErrado}</Label>}
                </ModalForm>
            } else {
                return  <ModalForm  salvando={this.controller.salvando} className="area-form-modal"
                                    onClickCancelar={() => this.controller.mostrarModalInativar = false}
                                    esconderSalvar={this.controller.deuErrado}
                                    labelConfirmar='SIM' 
                                    labelCancelar={!this.controller.deuErrado ? "NÃO" : "FECHAR"}
                                    onClickSalvar={() => this.controller.confirmaInativar(() => this.controllerImportacao.atualizaNotas(this.controllerImportacao.linhaDetalhes.BlId, this.controllerImportacao.linhaDetalhes.NumeroBl, this.controllerImportacao.linhaDetalhes.ProtocoloId))} >
                            <h2>{!this.controller.deuErrado ? "Confirma a inativação?" : "Erro ao inativar"}</h2>
                            {this.controller.deuErrado &&  <h4> {this.controller.deuErrado}</h4>}
                        </ModalForm>
            }
    };
    
    modalMudarTipoDoc = () => {
        if (this.controller.modalAvisoMudarTipoDoc)            
            return <ModalForm   className="tamanho-modal-acomproc" 
                                salvando={this.controller.salvando}
                                onClickCancelar={() => { this.mudarTipoDocValue = null; this.controller.modalAvisoMudarTipoDoc = false}}
                                labelConfirmar='SIM' labelCancelar="NÃO"
                                onClickSalvar={() => this.handleOnChangeTipoDeProcesso(this.mudarTipoDocValue)} >
                                <Label className="label-lg-black">ATENÇÃO!</Label>
                                <p />
                                <p className="text-desistencia">
                                    A troca do tipo de DOCUMENTO DE LIBERAÇÃO removerá permanentemente os documentos anexados do tipo DI, DSI, 
                                    Processo Administrativo e NFe!
                                </p>
                                <Label className="label-md-black mb-0">Deseja realmente realizar a troca do tipo de DOCUMENTO DE LIBERAÇÃO?</Label>
                    </ModalForm>
            
    };

    dadosGerais = (sm) => {
        let ce = this.controllerImportacao.linhaDetalhes.NumeroCe !== null ? this.controllerImportacao.linhaDetalhes.NumeroCe : "---";
        let navio = this.controllerImportacao.detalhes.Navio !== null ? this.controllerImportacao.detalhes.Navio : "---";
        let viagem = this.controllerImportacao.detalhes.CodViagem !== null ? this.controllerImportacao.detalhes.CodViagem : "";
        let cliente = this.controllerImportacao.detalhes.Cliente !== null ? this.controllerImportacao.detalhes.Cliente : "---";
        let despachante = this.controllerImportacao.detalhes.Despachante !== null ? this.controllerImportacao.detalhes.Despachante : "---";
        let numeroDi = this.controllerImportacao.detalhes.numeroDi !== null ? this.controllerImportacao.detalhes.numeroDi : "---";
        return <Col className="dados-gerais" xs={12} sm={12} md={12} lg={sm}>
            <h1>Dados Gerais</h1>
            <Card className="gerais">
                <Row>
                    <Col xs={12} sm={6} lg={12} xl={12} className="mb-3 containers-detalhes-col">
                        <Row>
                            <Col>
                                <Label className="label-secondary">CE</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label className="label-disabled">{ce}</Label>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} sm={6} lg={12} xl={12} className="mb-3 containers-detalhes-col">
                        <Row>
                            <Col>
                                <Label className="label-secondary">NAVIO / VIAGEM</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label className="label-disabled">{`${navio} - ${viagem}`}</Label>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} sm={6} lg={12} xl={12} className="mb-3 containers-detalhes-col">
                        <Row>
                            <Col>
                                <Label className="label-secondary">CLIENTE</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label className="label-disabled">{cliente}</Label>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} sm={6} lg={12} xl={12} className="containers-detalhes-col">
                        <Row>
                            <Col>
                                <Label className="label-secondary">DESPACHANTE</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label className="label-disabled">{despachante}</Label>
                            </Col>
                        </Row>
                    </Col>
                    {process.env.ssa && <Col xs={12} sm={6} lg={12} xl={12} className="containers-detalhes-col">
                        <Row>
                            <Col>
                                <Label className="label-secondary">Número DI</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label className="label-disabled">{numeroDi}</Label>
                            </Col>
                        </Row>
                    </Col>}
                    {process.env.ssa &&
                    <Col xs={12} sm={6} lg={12} xl={12} className="containers-detalhes-col">
                            <Button
                                disabled={this.controllerImportacao.linhaDetalhes.DesistVistoria}
                                className="btn-com-bordas-primary mt-0 ml-0 mr-0 mb-0"
                                style={{width: 'max-content'}}
                                onClick={() => this.controller.abrirDesistencia()}
                            >
                                Desistir da Vistoria de Lacre
                            </Button>
                    </Col> }
                </Row>
            </Card>
        </Col>;
    };

    pendencias = (titulo = "", dados, situacao, situacaoProtocolo, omitir) => {
        return <Col className="dados-gerais">
            <h1>{titulo}
                {situacao && <Label className={"situacao"}>{situacaoFormatter(situacao)}</Label>}
            </h1>
            <Container className={"card-branco pendencias"}>
                {omitir ?
                    <div className={`card-colorido card-colorido--disponivel`}>
                        <span>
                            <StatusOk className="card-colorido--icone" />
                        </span>
                        Para este Tipo de Processo não é necessária validação da SEFAZ
                        
                    </div>
                : situacaoProtocolo === 'DISPONÍVEL' ?
                    <div className={`card-colorido card-colorido--disponivel`}>
                        <span>
                            <StatusWarning className="card-colorido--icone" />
                        </span>
                        Aguardando envio de documentos
                    </div>
                : !dados || (situacao && situacao === "Liberado") ?
                   <div>
                            { dados && dados.length > 0 && (typeof(dados) ==="object") &&
                                dados.map((arq, x) => (
                                    <div className={`card-colorido card-colorido--ok`}>
                                        <span>
                                            <StatusOk className="card-colorido--icone" />
                                        </span>
                                        {`${arq}`}
                                    </div>
                                ))
                            }
                            { dados && dados.length > 0 && (typeof(dados) !="object") &&
                                <div className={`card-colorido card-colorido--ok`}>
                                    <span>
                                        <StatusOk className="card-colorido--icone" />
                                    </span>
                                    {`${dados}`}
                                </div>
                            }
                            {!dados &&
                                <div className={`card-colorido card-colorido--ok`}>
                                    <span>
                                        <StatusOk className="card-colorido--icone" />
                                    </span>
                                    {"Sem pendências"}
                                </div>
                            }
                    </div>
                    : <div>
                            { dados && dados.length > 0 && (typeof(dados) ==="object") &&
                                dados.map((arq, x) => (
                                    <div className={`card-colorido card-colorido--warning`}>
                                        <span>
                                            <StatusWarning className="card-colorido--icone" />
                                        </span> 
                                        {`${arq}`}
                                    </div>
                                ))
                            }
                            { dados && dados.length > 0 && (typeof(dados) !="object") &&
                                <div className={`card-colorido card-colorido--warning`}>
                                    <span>
                                        <StatusWarning className="card-colorido--icone" />
                                    </span>
                                    {`${dados}`}
                                </div>
                            }
                            {!dados &&
                                <div className={`card-colorido card-colorido--warning`}>
                                    {"Sem pendências"}
                                </div>
                            }
                    </div>
                }
            </Container>
        </Col>;
    };

    handleBlurEmail = (event) => {
        if (event !== null) {
            const email = event.target.value;
            this.controller.alertaEmail = false;

            if (email.length <= 1000) {
                let emails = email.split(",");

                let x = 0;
                while (x < emails.length && !this.controller.alertaEmail) {
                    let e = emails[x].trim();
                    if (e.length > 0) {
                        if (!this.validacaoStore.isEmail(e)) {
                            this.controller.alertaEmail = this.validacaoStore.getMensagemErro("isEmail");
                        } else {
                            emails[x] = e;
                        }
                    } else {
                        emails.splice(x, 1);
                        x--;
                    }
                    x++;
                }

                if (!this.controller.alertaEmail) {
                    let emailEnviar = "";
                    for (let x = 0; x < emails.length - 1; x++) {
                        emailEnviar += emails[x] + ",";
                    }
                    emailEnviar += emails[emails.length - 1];
                    this.controller.salvarEmail(emailEnviar, this.controllerImportacao.linhaDetalhes.ProtocoloId);
                }
            } else {
                this.controller.alertaEmail = "Limite de 1000 caracteres";
            }
        }
    };
    
    email = () => {        
        return <Col xs={12} sm={12} md={6} lg={6} xl={6} className="dados-gerais">
            <Card>
                <Row className="area-form dados-gerais--conteudo">
                    {/**TODO: Colocar uma classe para align-itens: center */}
                    <Col xs={12} sm={12} md={12} lg={12} xl={6}>
                        <IconeNaoMsgLida className="mr-3" tamanho="3x" />
                        <Label className={"lbl-informe"}>INFORME O E-MAIL PARA RECEBIMENTO DE BOOKING</Label>
                    </Col>
                    
                    <FormInputSimples className={"mb-0"} xs={12} sm={12} md={12} lg={12} xl={6}
                        limiteMaximo={255}
                        dado={this.controllerImportacao.detalhes.Email }
                        onChange={() => { }}
                        onBlur={this.handleBlurEmail}
                        bloqueado={this.controllerImportacao.detalhes.Situacao === "OK"}
                        alerta={!this.controller.salvandoEmail ? this.controller.alertaEmail : false}
                        extraInfo={"Para inclusão de mais de um email, utilize separação por vírgula"}
                        extraInfoSmaller={true}
                    />
                </Row>
            </Card>
            
        </Col>;
    };
    
    handleDesistencia() {
        this.controller.desistirVistoria(this.controllerImportacao.linhaDetalhes.BlId);
        this.controller.fecharDesistencia();
    }

    modalDesistencia() {
        return this.controller.showModalDesistencia &&
            <ModalForm
                className="tamanho-modal-acomproc"
                labelConfirmar="SIM"
                labelCancelar="NÃO"
                onClickSalvar={this.handleDesistencia}
                onClickCancelar={() => this.controller.fecharDesistencia()}
            >
                <h2>Você realmente deseja desistir da vistoria de lacre?</h2>
                {!process.env.rig
                    ? <p className="text-desistencia">Presença de carga enviada sem a conferência física da carga.
                    Caso o importador prefira aguardar a conferência física para avaliar a integridade da carga,
                antes do registro da DI, deverá programar a desova e conferência junto ao {!process.env.rig ? "Atendimento ao Cliente" : "GAC"}.</p>
                    : <p className="text-desistencia">O Importador acima mencionado, através de seu representante abaixo assinado,
                        DESISTE da vistoria dos volumes acima citados, assumindo inteira responsabilidade pelo ônus
                        decorrente desta desistência e DECLARA concordar que após a retirada da carga das dependências do TECON RIO GRANDE S/A,
                        o referido terminal está isento de qualquer responsabilidade sobre o conteúdo da carga, razão pela qual, em nenhuma hipótese
                    poderá ser responsabilizado por qualquer custo e/ou dano direto ou indireto.</p>
                }
            </ModalForm>
    }

    modalMensagemDesistencia(){
        return this.controller.desistenciaMensagem !== "" && <ModalAviso
            onClickFechar={() => this.controller.desistenciaMensagem = ""}
        >
            <h2>
                {this.controller.desistenciaMensagem}
            </h2>
        </ModalAviso>
    }

    processo = () => {
        if (this.controllerImportacao.detalhes) {
            if (_.isEmpty(this.controller.tipoDeProcessoSelecionado)) {
                if (this.controllerImportacao.detalhes.TipoProtocoloObj)
                {
                    this.controller.tipoDeProcessoSelecionado.label = this.controllerImportacao.detalhes.TipoProtocoloObj.Nome;
                    this.controller.tipoDeProcessoSelecionado.value = this.controllerImportacao.detalhes.TipoProtocoloObj.Id;
                    this.controllerImportacao.listarTiposDocumento(this.controllerImportacao.linhaDetalhes.BlId, this.controller.tipoDeProcessoSelecionado);
                }
            }

            return <Col xs={12} sm={12} md={6} lg={6} xl={6} className="dados-gerais">
                <Card>
                    <Row className="area-form dados-gerais--conteudo">
                        <Col xs={12} sm={12} md={12} lg={12} xl={6}>
                            <Monitor className="mr-3" tamanho="3x" />
                            <Label className={"lbl-informe"}>INFORME O TIPO DE PROCESSO</Label>
                        </Col>
                        <FormSelectSimples className={"mb-0"} xs={12} sm={12} md={12} lg={12} xl={6}
                            naoLimpar={true}
                            itens={this.controllerImportacao.tiposDeProcesso}
                            dado={this.controller.tipoDeProcessoSelecionado}
                            bloqueado={this.controllerImportacao.detalhes.Situacao === "OK" || !this.controllerImportacao.tiposDeProcesso}
                            alerta={this.controller.alertaProcesso}
                            onChange={(event) => this.avisoMudarTipo(event)} />
                    </Row>
                </Card>
            </Col>;
        }
        else{
            this.controller.tipoDeProcessoSelecionado = {};
        }
    };

    handleOnChangeTipoDeProcesso = async (event) => {
        this.controller.modalAvisoMudarTipoDoc = false;
        this.controller.atualizaDadosProcesso = false;
        await this.controller.onChangeTipoDeProcesso(event, this.controllerImportacao.detalhes.ProtocoloId);
        
        await this.controllerImportacao.listarTiposDocumento(this.controllerImportacao.linhaDetalhes.BlId, 
                                                             this.controller.tipoDeProcessoSelecionado);
         this.controller.atualizaDadosProcesso = true;
    }

    avisoMudarTipo = (event) => {
        if (this.controller.tipoDeProcessoSelecionado && this.controller.tipoDeProcessoSelecionado.value)
        {
            if (event && this.controller.tipoDeProcessoSelecionado && event.value != this.controller.tipoDeProcessoSelecionado.value) 
            {
                this.mudarTipoDocValue = event;
                this.controller.modalAvisoMudarTipoDoc = true;

            }
            else
                this.mudarTipoDocValue = null;
        }
        else
        {
            this.handleOnChangeTipoDeProcesso(event);
        }
    }

    modalCarregarDoc() {
        if (this.controller.modalCarregarDoc)
            return <ImportacaoDocsImportar controllerImportacao={this.controllerImportacao} controller={this.controller} service={this.service} />
    };

    documentos = () => {
        let lista = this.controllerImportacao.detalhes.ListaDocumentos ? this.controllerImportacao.detalhes.ListaDocumentos : [];
        return <Row>
            <Col xl={12}>
                <div className="card-expansivel card-expansivel-tabela">
                    <div className={"card"} >
                        <Row className="titulo-booking">
                            <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                                <h4>Documentos</h4>
                            </Col>
                            <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                                <div className="float-right">
                                    {process.env.ssa && this.controllerImportacao.detalhes.TipoProtocolo === "DA" && this.controllerImportacao.detalhes.ProtocoloIdPai === null && !this.controllerImportacao.loadingNovoDi && <Button className="btn-com-bordas-primary btn-filtrar" onClick={() => this.controllerImportacao.abrirModalNovaDi(this.controllerImportacao.detalhes, this.props.mudaTitulo())}>Inserir nova DI</Button>}
                                    {process.env.ssa && this.controllerImportacao.detalhes.TipoProtocolo === "DA" && this.controllerImportacao.detalhes.ProtocoloIdPai === null && this.controllerImportacao.loadingNovoDi && <IconeCarregar tamanho="sm" />}
                                    <Button className="btn-com-bordas-primary btn-filtrar" disabled={this.controllerImportacao.detalhes.Situacao === "OK" || _.isEmpty(this.controller.tipoDeProcessoSelecionado)} onClick={() => this.controller.modalCarregarDoc = true}>Inserir novo</Button>
                                    <Button onClick={() => this.controller.cliqueExpandirDocumento()} outline className="collapseItem collapseItem-small" active={this.controller.documentosExpandido}>
                                        {this.controller.documentosExpandido ? <IconeSetaSubir /> : <IconeSetaDescer />}
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                        {this.controller.documentosExpandido &&
                            <React.Fragment>
                                <ToolkitProvider
                                    keyField="InfDocId"
                                    data={lista.slice()}
                                    columns={[...this.controller.colunasDocumentos]}>
                                    {props => (
                                        <div className="tabela-overflow">
                                            <BootstrapTable bootstrap4
                                                striped
                                                bordered={false}
                                                noDataIndication={() => this.controller.tableMessage}
                                                classes="tabela tabela-layout"
                                                {...props.baseProps} />
                                        </div>
                                    )}
                                </ToolkitProvider>
                            </React.Fragment>
                        }
                    </div>
                </div>
            </Col>
        </Row>
    };

    modalAdicionarChaves() {
        if (this.controller.modalAdicionarChaves)
            return <ImportacaoNotasAdicionar controllerImportacao={this.controllerImportacao} controller={this.controller} service={this.service} />
    };

    notasFiscais = () => {
        // comentário aleatório para subir a versão
        let lista = this.controllerImportacao.detalhes.ListaNf ? this.controllerImportacao.detalhes.ListaNf : [];
        return <Row>
                    {this.controller.tipoDeProcessoSelecionado && this.controller.tipoDeProcessoSelecionado.value!=2 &&
                    <Col xl={12}>
                        <div className="card-expansivel card-expansivel-tabela">
                            <div className={"card"} >
                                <Row className="titulo-booking">
                                    <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                                        <h4>Notas Fiscais</h4>
                                    </Col>
                                    <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                                        <div className="float-right">
                                            <Button className="btn-com-bordas-primary btn-filtrar" disabled={this.controllerImportacao.detalhes.Situacao === "OK" || _.isEmpty(this.controller.tipoDeProcessoSelecionado)} onClick={() => this.controller.modalAdicionarChaves = true}>Inserir novo </Button>
                                            <Button onClick={() => this.controller.cliqueExpandirNotas()} outline className="collapseItem collapseItem-small" active={this.controller.notasExpandido}>
                                                {this.controller.notasExpandido ? <IconeSetaSubir /> : <IconeSetaDescer />}
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                                {this.controller.notasExpandido &&
                                    <React.Fragment>
                                        <ToolkitProvider
                                            keyField="Id"
                                            data={lista.slice()}
                                            columns={[...this.controller.colunasNotas]}>
                                            {props => (
                                                <div className="tabela-overflow">
                                                    <BootstrapTable bootstrap4
                                                        striped
                                                        bordered={false}
                                                        noDataIndication={() => this.controller.tableMessage}
                                                        classes="tabela tabela-layout"
                                                        {...props.baseProps} />
                                                </div>
                                            )}
                                        </ToolkitProvider>
                                    </React.Fragment>
                                }
                            </div>
                        </div>
                    </Col>}
                </Row>
    };

    bookings = () => {
        let lista = this.controllerImportacao.detalhes.ListaBookings ? this.controllerImportacao.detalhes.ListaBookings : [];
        if (lista.length > 0)
            return <Row>
                <Col xl={12}>
                    <div className="card-expansivel card-expansivel-tabela">
                        <div className={"card"} >
                            <Row className="titulo-booking">
                                <Col>
                                    <h4>Booking</h4>
                                </Col>
                                <Col>
                                    <div className="float-right">
                                        <Button onClick={() => this.controller.cliqueExpandirBookings()} outline className="collapseItem collapseItem-small" active={this.controller.bookingsExpandido}>
                                            {this.controller.bookingsExpandido ? <IconeSetaSubir /> : <IconeSetaDescer />}
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                            {this.controller.bookingsExpandido &&
                                <React.Fragment>
                                    <ToolkitProvider
                                        keyField="BookingId"
                                        data={lista.slice()}
                                        columns={[...this.controller.colunasBookings]}>
                                        {props => (
                                            <div className="tabela-overflow">
                                                <BootstrapTable bootstrap4
                                                    striped
                                                    bordered={false}
                                                    noDataIndication={() => this.controller.tableMessage}
                                                    classes="tabela tabela-layout"
                                                    {...props.baseProps} />
                                            </div>
                                        )}
                                    </ToolkitProvider>
                                </React.Fragment>
                            }
                        </div>
                    </div>
                </Col>
            </Row>
    };

    handleEnviarPraAnalise = () => {
        this.controller.enviarPraAnalise(this.controllerImportacao.detalhes.ProtocoloId, this.controllerImportacao, this.props.mudaTitulo);
    };

    aviso = () => {
        if (this.controller.listaMensagens)
            return <ModalAviso onClickFechar={() => this.controller.listaMensagens = false} >
                        <h2>{this.controller.listaMensagens}</h2>
                    </ModalAviso>
    };

    render() {
        return (
            <div className={!this.controllerImportacao.detalhesAtivo ? "importacao-detalhes escondido" : "importacao-detalhes"}>
                {this.modalCarregarDoc()}
                {this.modalAdicionarChaves()}
                {this.modalInativar()}
                {this.modalMudarTipoDoc()}
                {this.modalDesistencia()}
                {this.modalMensagemDesistencia()}
                {this.aviso()}
                <Row >
                    {this.dadosGerais(3)}
                    {this.pendencias("TECON",
                        this.controllerImportacao.detalhes.PendenciaTecon,
                        null,
                        this.controllerImportacao.detalhes.Situacao)}
                    {this.pendencias("SEFAZ",
                        this.controllerImportacao.detalhes.PendenciaSefaz,
                        this.controllerImportacao.detalhes.StatusSefaz, 
                        this.controllerImportacao.detalhes.Situacao,
                        this.controllerImportacao.detalhes 
                        && this.controllerImportacao.detalhes.TipoProtocolo 
                        && this.controllerImportacao.detalhes.TipoProtocolo === "DSI")}
                </Row>
                <Row>
                    {this.email()}
                    {this.controller.atualizaDadosProcesso && this.processo()}
                </Row>
                {this.documentos()}
                {this.notasFiscais()}
                {this.bookings()}

                <Footer className="importacao-detalhes-footer justify-content-end">
                    {!this.controller.salvar
                        ? <React.Fragment>
                            <Button className="btn-primary" onClick={() => this.handleFechar()}>FECHAR</Button>
                            <Button className="btn-primary" disabled={this.controllerImportacao.detalhes.Situacao === "OK"} onClick={() => this.handleEnviarPraAnalise()}>ENVIAR PARA ANÁLISE</Button>
                        </React.Fragment>
                        : <IconeCarregar tamanho="2x" cor="#001C43" />
                    }
                </Footer>
            </div>
        )
    };
};



// WEBPACK FOOTER //
// ./src/modules/liberacoes/importacao/components/ImportacaoDetalhes.js